import { useState } from 'react';
import * as React from 'react';
import { __ } from 'react-i18n';
import { Button } from '../../General/Button';
import styled from 'styled-components';

interface Props {
  shop: any;
  handleActiveShopChange: any;
  isActive: boolean;
  handleChooseShop: any;
}

const MainWrapper = styled.div`
  justify-items: center;
  width: 100%;
  border-top-width: 1px;
  padding: 1rem;
  display: flex;
  flex-direction: column;
  --tw-border-opacity: 1;
  border-color: rgba(243, 244, 246, var(--tw-border-opacity));
  align-items: center;
  cursor: pointer;

  &:hover {
    --tw-bg-opacity: 1;
    background-color: rgba(243, 244, 246, var(--tw-bg-opacity));
  }
`;

const ListItemWrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  cursor: pointer;
`;

const ListItem = styled.div`
  margin-left: 1rem;
`;

const CustomButton = styled(Button)`
  margin-top: 0.5rem;
  margin-bottom: 0.5rem;
  margin-left: auto;
  margin-right: auto;
  font-weight: 700;
  max-width: 75%;
  margin-top: 1rem;
`;

const ActiveWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  background-color: #f3f4f6;
  align-items: center;
`;

const AddressInfo = styled.p`
  margin: 0;
`;

export default function DpdMapDetail(props: Props) {
  const { shop, handleActiveShopChange, isActive, handleChooseShop } = props;
  const [showDetail, setShowDetail] = useState(false);
  // const openingHours = JSON.parse(shop.opening_hours_json);
  const workDays: any = [];

  const handleShowDetail = () => {
    handleActiveShopChange(shop);
  };

  const handleChooseShopClick = () => {
    handleChooseShop(shop);
  };

  return (
    <MainWrapper
      id={shop.id}
      key={shop.id}
      className={`items-center w-full border-gray-100 hover:bg-gray-100 border-t-1 p-4 flex flex-col ${
        isActive ? 'bg-gray-100' : ''
      }`}
      onClick={handleShowDetail}
    >
      <ListItemWrapper className="w-full flex flex-row hover:cursor-pointer">
        <div className={'bg-sps-logo w-10 h-8 bg-contain bg-no-repeat'} />
        <ListItem className={'ml-4'}>
          <strong>{`${shop.name || shop.company || ''}`}</strong>
          <AddressInfo>
            {`${shop.street} ${shop.houseno || shop.house_number || ''} ${
              shop.city
            }, ${shop.postcode}`}
          </AddressInfo>
        </ListItem>
      </ListItemWrapper>

      {isActive ? (
        <ActiveWrapper className="flex flex-col w-full bg-gray-100 items-center">
          {workDays.length > 0
            ? workDays.map((day, i) => {
                return (
                  <div
                    key={i}
                    className={
                      'w-full my-4 flex flex-row items-center justify-center'
                    }
                  >
                    <strong
                      className={'mr-16'}
                    >{`${day._attributes.date.replace('-', '.')}: `}</strong>
                    <p>{`${day.workHours._text}`}</p>
                  </div>
                );
              })
            : null}

          <CustomButton
            className="my-2 mx-auto font-bold max-w-[75%] mt-4"
            onClick={handleChooseShopClick}
          >
            {__('Vyzdvihnúť tu')}
          </CustomButton>
        </ActiveWrapper>
      ) : null}
    </MainWrapper>
  );
}
